import React, {useEffect, useState} from "react";
import Checkbox from "@mui/material/Checkbox";
import {FixedSizeList as List} from "react-window";
import InputForm from "./ComponentesFormularios/InputForm";
import {Colors} from "../assets/colors/Colors";
import {validArray} from "../util/functions";

const RenderList = ({dataList = [], dataMov = [], identificador = "none", lockInputSearch = false, handleChange, disabled = false}) => {

    const [ stateDataList, setStateDataList ] = useState({data: dataList, dataFilter: dataList});
    const [ stateValueFilter, setStateValueFilter ] = useState("");
    const { data, dataFilter } = stateDataList;


    useEffect(() => {
      setStateDataList({...stateDataList, data: dataFilter?.filter(x => (x?.text?.toUpperCase()?.includes(stateValueFilter?.toUpperCase())) ||
            (x?.id?.includes(stateValueFilter))
          )});
    }, [stateValueFilter])

    useEffect(() => {
        setStateDataList({...stateDataList, data: dataList?.filter(x => x?.text?.toUpperCase()?.includes(stateValueFilter?.toUpperCase())), dataFilter: dataList});
    }, [dataList])


    return(

        <div>

        <InputForm identificador={`buscar${identificador}`} type="text" label="" value={stateValueFilter}
                   handleChange={({value}) => setStateValueFilter(value)}
                   placeholder="Buscar..." disabled={lockInputSearch} className={`pr-2 w-100`}/>

        <List id={identificador} height={400} width={`100%`} itemSize={46} itemCount={data.length} className={`border${identificador}`}>

            {

                ({index,style}) =>
                    <div key={`key${identificador}${index}`} style={style} className="d-flex align-items-center p-2">
                        <div>
                            <Checkbox
                                disabled={disabled}
                                checked={dataMov.findIndex(x => x.id === data[index]?.id) !== -1}
                                inputProps={{ 'aria-labelledby': data[index]?.id, 'data-id': data[index]?.id, 'data-name': data[index]?.text }}
                                onChange={({target:{attributes, checked}}) => handleChange({attributes, checked})}
                            />
                        </div>
                        <div className="ml-2">{data[index]?.id} - {data[index]?.text}</div>
                    </div>

            }

        </List>
        <div><p className="mw-100 text-justify p-2 font-weight-bold" style={{color: Colors.RED_SWITCH_INACTIVE}}>{`${dataMov.length}/${dataList.length} Seleccionados`}</p></div>
        </div>
    )

}

const TransfertList = ({dataShow = [] , dataSelect = [] , labelMuestra = "Label Muestra", labelSelected = "Label Seleccionados", onChange, disabled = false}) => {


    const [ stateData, setStateData ] = useState({ dataMuestra: validArray(dataShow), dataSelected: validArray(dataSelect), dataAdd: [], dataDelete: [] });
    const { dataMuestra, dataSelected, dataAdd, dataDelete} = stateData;

    const handleChangeCheckBoxMuestra = ({attributes, checked}) => {

        const id = attributes.getNamedItem('data-id').value;
        const text = attributes.getNamedItem('data-name').value;

        let existe = false;

        for(let item of dataAdd){
            if(item.id === id){
                existe = true;
                break;
            }
        }

        if(!existe){
            const obj = {id, text};
            setStateData({...stateData, dataAdd: [ ...dataAdd, obj ] });
        }
        else{
            setStateData({...stateData, dataAdd: dataAdd.filter(i => i.id !== id) });
        }

    }

    const handleChangeCheckBoxSelected = ({attributes, checked}) => {

        const id = attributes.getNamedItem('data-id').value;
        const text = attributes.getNamedItem('data-name').value;

        let existe = false;

        for(let item of dataDelete){
            if(item.id === id){
                existe = true;
                break;
            }
        }

        if(!existe){
            const obj = {id, text};
            setStateData({...stateData, dataDelete: [ ...dataDelete, obj ] });
        }
        else{
            setStateData({...stateData, dataDelete: dataDelete.filter(i => i.id !== id) });
        }

    }

    const agregarMuestraToSelected = () => {

        const dataMuestraTemp = dataMuestra.slice();
        const dataSelectedTemp = dataSelected.slice();

        for (let i = dataAdd.length - 1; i >= 0; i--) {
            const position = dataMuestraTemp.findIndex(x => x.id === dataAdd[i]?.id);
            if(position !== -1){
                dataMuestraTemp.splice(position, 1)
            }
            dataSelectedTemp.push(dataAdd[i]);
        }

        setStateData({...stateData, dataMuestra: dataMuestraTemp , dataSelected: dataSelectedTemp, dataAdd: []});
        onChange({dataSelectedTemp});
    }

    const agregarSelectedToMuestra = () => {

        const dataMuestraTemp = dataMuestra.slice();
        const dataSelectedTemp = dataSelected.slice();

        for (let i = dataDelete.length - 1; i >= 0; i--) {
            const position = dataSelectedTemp.findIndex(x => x.id === dataDelete[i]?.id);
            if(position !== -1){
                dataSelectedTemp.splice(position, 1)
            }
            dataMuestraTemp.push(dataDelete[i]);
        }

        setStateData({...stateData, dataMuestra: dataMuestraTemp , dataSelected: dataSelectedTemp, dataDelete: []});
        onChange({dataSelectedTemp});
    }

    useEffect(() => {

        const dataMuestraTemp = validArray(dataShow).slice();
        const dataSelectedTemp = validArray(dataSelect).slice();

        for (let i = dataSelectedTemp.length - 1; i >= 0; i--) {
            const position = dataMuestraTemp.findIndex(x => x.id === dataSelectedTemp[i]?.id);
            if(position !== -1){
                dataMuestraTemp.splice(position, 1)
            }
        }

        setStateData({dataMuestra: dataMuestraTemp, dataSelected: dataSelect, dataAdd: [], dataDelete: [] });

    }, [dataShow, dataSelect])

    return (
        <div className="d-flex align-items-center justify-content-between">
            <div style={{width: '45%'}}>

                <div style={{height: 100}}>
                <div><h6 className="w-100 text-center p-3 colorMuestra">{labelMuestra}</h6></div>
                </div>

                <RenderList disabled={disabled} dataList={dataMuestra} dataMov={dataAdd} identificador="ListMuestra" lockInputSearch={dataMuestra.length === 0} handleChange={({attributes, checked}) => handleChangeCheckBoxMuestra({attributes, checked})} />

            </div>

            <div style={{width: '10%'}} className="mx-5">
                {   dataAdd.length > 0 ?
                    <div onClick={() => agregarMuestraToSelected()}
                         className="container-btn-agregar-remove position-relative d-flex align-items-center justify-content-center p-2 my-4">
                        <div className="btnAgregarTL position-absolute w-100 h-100"/>
                        <a className="colorBtnAgregarTl">
                            <span>Agregar</span>
                            <i style={{marginLeft: 5}} className="fas fa-forward"/>
                        </a>
                    </div>
                    :
                    <div
                         className="container-btn-agregar-remove position-relative d-flex align-items-center justify-content-center p-2 my-4">
                        <div className="btnAgregarTLDisabled position-absolute w-100 h-100"/>
                        <a className="colorBtnAgregarTlDisabled">
                            <span>Agregar</span>
                            <i style={{marginLeft: 5}} className="fas fa-forward"/>
                        </a>
                    </div>
                }
                {   dataDelete.length > 0 ?
                    <div onClick={() => agregarSelectedToMuestra()}
                         className="container-btn-agregar-remove position-relative d-flex align-items-center justify-content-center p-2 my-4">
                        <div className="btnRemoveTL position-absolute w-100 h-100"/>
                        <a className="colorBtnRemoveTl">
                            <span>Eliminar</span>
                            <i style={{marginLeft: 5}} className="fas fa-trash"/>
                        </a>
                    </div>
                    :
                    <div
                         className="container-btn-agregar-remove position-relative d-flex align-items-center justify-content-center p-2 my-4">
                        <div className="btnRemoveTLDisabled position-absolute w-100 h-100"/>
                        <a className="colorBtnRemoveTlDisabled">
                            <span>Eliminar</span>
                            <i style={{marginLeft: 5}} className="fas fa-trash"/>
                        </a>
                    </div>
                }
            </div>

            <div style={{width: '45%'}}>

                <div style={{height: 100}}>
                <div><h6 className="w-100 text-center p-3 colorSelected">{labelSelected}</h6></div>

                <div><p className="mw-100 text-justify px-2">Seleccione los items de la sección <span className="colorMuestra">"{labelMuestra.toLowerCase()}"</span> y agreguelos a la sección <span className="colorSelected">"{labelSelected.toLowerCase()}"</span></p></div>
                </div>

                <RenderList disabled={disabled} dataList={dataSelected} dataMov={dataDelete} identificador="ListSelected" lockInputSearch={dataSelected.length === 0} handleChange={({attributes, checked}) => handleChangeCheckBoxSelected({attributes, checked})} />

            </div>

        </div>
    );

}

export default TransfertList;
